"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantSepaDirectDebitAuthorisationResultAllOfToJSON = exports.GrantSepaDirectDebitAuthorisationResultAllOfFromJSONTyped = exports.GrantSepaDirectDebitAuthorisationResultAllOfFromJSON = void 0;
var runtime_1 = require("../runtime");
function GrantSepaDirectDebitAuthorisationResultAllOfFromJSON(json) {
    return GrantSepaDirectDebitAuthorisationResultAllOfFromJSONTyped(json, false);
}
exports.GrantSepaDirectDebitAuthorisationResultAllOfFromJSON = GrantSepaDirectDebitAuthorisationResultAllOfFromJSON;
function GrantSepaDirectDebitAuthorisationResultAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'downloadUrl': !(0, runtime_1.exists)(json, 'downloadUrl') ? undefined : json['downloadUrl'],
    };
}
exports.GrantSepaDirectDebitAuthorisationResultAllOfFromJSONTyped = GrantSepaDirectDebitAuthorisationResultAllOfFromJSONTyped;
function GrantSepaDirectDebitAuthorisationResultAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'downloadUrl': value.downloadUrl,
    };
}
exports.GrantSepaDirectDebitAuthorisationResultAllOfToJSON = GrantSepaDirectDebitAuthorisationResultAllOfToJSON;
//# sourceMappingURL=GrantSepaDirectDebitAuthorisationResultAllOf.js.map